import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const TeacherRoute = ({ children }) => {
  const { currentUser } = useAuth();
  if (!currentUser || !currentUser.role === "teacher") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default TeacherRoute;
